module.exports = __webpack_public_path__ + "img/feature_wy_bg.b90f5ca0.png";